import { Injectable } from '@angular/core';
import { ExpandMode } from './expand-mode';
var TreeSelectDefaultOptions = /** @class */ (function () {
    function TreeSelectDefaultOptions() {
        this.expandMode = ExpandMode.None;
    }
    TreeSelectDefaultOptions.decorators = [
        { type: Injectable },
    ];
    /**
     * @nocollapse
     */
    TreeSelectDefaultOptions.ctorParameters = function () { return []; };
    return TreeSelectDefaultOptions;
}());
export { TreeSelectDefaultOptions };
function TreeSelectDefaultOptions_tsickle_Closure_declarations() {
    /** @type {?} */
    TreeSelectDefaultOptions.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    TreeSelectDefaultOptions.ctorParameters;
    /** @type {?} */
    TreeSelectDefaultOptions.prototype.allowFilter;
    /** @type {?} */
    TreeSelectDefaultOptions.prototype.filterPlaceholder;
    /** @type {?} */
    TreeSelectDefaultOptions.prototype.maxVisibleItemCount;
    /** @type {?} */
    TreeSelectDefaultOptions.prototype.allowParentSelection;
    /** @type {?} */
    TreeSelectDefaultOptions.prototype.idField;
    /** @type {?} */
    TreeSelectDefaultOptions.prototype.textField;
    /** @type {?} */
    TreeSelectDefaultOptions.prototype.childrenField;
    /** @type {?} */
    TreeSelectDefaultOptions.prototype.filterCaseSensitive;
    /** @type {?} */
    TreeSelectDefaultOptions.prototype.expandMode;
}
//# sourceMappingURL=tree-select-default-options.js.map


//////////////////
// WEBPACK FOOTER
// ./.tmp/custom-tree-select/src/models/tree-select-default-options.js
// module id = 39
// module chunks = 0